module.exports = __webpack_public_path__ + "static/media/React95Video-Numbers.05f2a2b6.woff";